<template>
  <div class="main-content log-page"><div class="container">
    <div class="header-section"><span class="eyebrow">DATABASE HISTORY</span><h1>Version log</h1><p class="lead">A record of CoExCell data and feature updates.</p></div>
    <div class="panel log-list">
      <div v-for="entry in entries" :key="entry.date" class="log-entry"><div class="date">{{ entry.date }}</div><div><h2>{{ entry.title }}</h2><p>{{ entry.description }}</p></div></div>
    </div>
  </div></div>
</template>
<script>
export default { name: 'VersionLog', data: () => ({ entries: [
  { date: '2025/09', title: 'Added single-cell coexpression data', description: 'Introduced cell type-specific coexpression results for single-cell RNA-seq datasets.' },
  { date: '2025/12', title: 'Added spatial coexpression data', description: 'Added spatially resolved coexpression results and dataset views.' },
  { date: '2026/03', title: 'V1.0 release', description: 'Added coexpression module data and functional annotations.' },
  { date: '2026/10', title: 'V1.1 release', description: 'Updated coexpression results, added cross-dataset consensus scores and a full correlation download page.' }
] }) };
</script>
<style scoped>
.main-content { background: var(--bg); min-height: 100vh; padding: 30px 0 56px; font-family: 'Inter', sans-serif; color: var(--navy); }
.container { max-width: 1180px; margin: 0 auto; padding: 0 20px; }
.header-section { margin-bottom: 30px; text-align: center; }
.header-section h1 { margin: 8px 0 10px; font-size: 42px; }
.lead { color: var(--muted); font-size: 18px; line-height: 1.6; }
.panel { padding: 30px; background: linear-gradient(180deg, #f9fbfe 0%, #d8e1ee 100%); border: 1px solid var(--border); border-radius: 20px; box-shadow: var(--shadow); }
.eyebrow { color: var(--accent); font-size: 11px; font-weight: 700; letter-spacing: 1.2px; }
.header-section h1 { margin: 6px 0; color: var(--navy); font-family: 'Playfair Display', serif; }
.log-list { max-width: 860px; margin: 0 auto; }
.log-entry { display: grid; grid-template-columns: 110px 1fr; gap: 28px; padding: 24px 0; border-bottom: 1px solid var(--border); }
.log-entry:last-child { border-bottom: 0; }
.date { color: var(--accent); font-weight: 700; }
.log-entry h2 { margin: 0 0 7px; color: var(--navy); font-size: 18px; }
.log-entry p { margin: 0; color: var(--muted); line-height: 1.6; }
@media (max-width: 600px) { .panel { padding: 22px 18px; } .log-entry { grid-template-columns: 1fr; gap: 8px; } }
</style>
